(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var btn = document.querySelector('[data-action="footer-share"]');
    if (!btn) return;

    var popup = document.getElementById('gaf-share-popup');
    if (!popup) return;

    var copyBtn = popup.querySelector('[data-share="copy"]');
    var instaBtn = popup.querySelector('[data-share="instagram"]');
    var copyTimer;
    var isOpen = false;

    function buildUrls() {
      var url = encodeURIComponent(location.href);
      var title = encodeURIComponent(document.title);
      popup.querySelector('[data-share="email"]').href =
        'mailto:?subject=' + title + '&body=' + url;
      popup.querySelector('[data-share="whatsapp"]').href =
        'https://wa.me/?text=' + url;
      popup.querySelector('[data-share="facebook"]').href =
        'https://www.facebook.com/sharer/sharer.php?u=' + url;
      popup.querySelector('[data-share="x"]').href =
        'https://twitter.com/intent/tweet?url=' + url + '&text=' + title;
    }

    function clampPosition() {
      popup.style.left = '';
      popup.style.right = '';
      popup.style.transform = '';
      var rect = popup.getBoundingClientRect();
      var pad = 12;
      if (rect.right > window.innerWidth - pad) {
        popup.style.left = 'auto';
        popup.style.right = '0';
        popup.style.transform = 'translateY(0)';
        popup.querySelector('.gaf-share-popup__arrow').style.left = 'auto';
        popup.querySelector('.gaf-share-popup__arrow').style.right = '16px';
      } else if (rect.left < pad) {
        popup.style.left = '0';
        popup.style.transform = 'translateY(0)';
        popup.querySelector('.gaf-share-popup__arrow').style.left = '16px';
      }
    }

    function openPopup() {
      buildUrls();
      popup.removeAttribute('hidden');
      requestAnimationFrame(function () {
        popup.classList.add('is-open');
        clampPosition();
      });
      btn.setAttribute('aria-expanded', 'true');
      isOpen = true;
    }

    function closePopup() {
      popup.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      isOpen = false;
      setTimeout(function () {
        if (!isOpen) popup.setAttribute('hidden', '');
      }, 180);
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      isOpen ? closePopup() : openPopup();
    });

    function showCopied(el) {
      clearTimeout(copyTimer);
      el.classList.add('is-copied');
      copyTimer = setTimeout(function () { el.classList.remove('is-copied'); }, 2000);
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        navigator.clipboard.writeText(location.href).then(function () {
          showCopied(copyBtn);
        });
      });
    }

    if (instaBtn) {
      instaBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        navigator.clipboard.writeText(location.href).then(function () {
          showCopied(instaBtn);
          setTimeout(function () { window.open('https://www.instagram.com/', '_blank', 'noopener'); }, 400);
        });
      });
    }

    document.addEventListener('click', function (e) {
      if (isOpen && !popup.contains(e.target) && e.target !== btn) closePopup();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) closePopup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sliders = document.querySelectorAll('[data-hero-slider]');

  sliders.forEach(function (slider) {
    var track = slider.querySelector('[data-hero-track]');
    var slides = slider.querySelectorAll('[data-slide-index]');
    var dots = slider.querySelectorAll('[data-hero-dot]');
    var prevBtn = slider.querySelector('[data-hero-prev]');
    var nextBtn = slider.querySelector('[data-hero-next]');

    if (!track || slides.length < 2) return;

    var current = 0;
    var isRTL = document.documentElement.dir === 'rtl';
    var autoplay = slider.dataset.autoplay === 'true';
    var speed = parseInt(slider.dataset.autoplaySpeed, 10) || 5000;
    var timer = null;

    function goTo(index) {
      current = ((index % slides.length) + slides.length) % slides.length;
      var offset = isRTL ? current * 100 : -current * 100;
      track.style.transform = 'translateX(' + offset + '%)';

      dots.forEach(function (dot, i) {
        var active = i === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function startAutoplay() {
      if (!autoplay) return;
      timer = setInterval(function () { goTo(current + 1); }, speed);
    }

    function stopAutoplay() { clearInterval(timer); }

    if (prevBtn) prevBtn.addEventListener('click', function () { stopAutoplay(); goTo(current - 1); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stopAutoplay(); goTo(current + 1); startAutoplay(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stopAutoplay();
        goTo(parseInt(this.dataset.heroDot, 10));
        startAutoplay();
      });
    });

    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { stopAutoplay(); goTo(isRTL ? current + 1 : current - 1); startAutoplay(); }
      if (e.key === 'ArrowRight') { stopAutoplay(); goTo(isRTL ? current - 1 : current + 1); startAutoplay(); }
    });

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
